import { BindingEngine } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";
import { ManageVesselService } from "../../../../../../services/vessels/manage-vessel.service";
import { VesselPortCallRiskScoreModel, VesselPreArrivalDetailsModel } from "../../../ports-and-terminals/models/ports-and-terminals.models";
import { VesselFbrPerformance } from "../../../vessels/steps/vessel-fbr-performance";
import { VesselLists } from "../../../vessels/steps/vessel-lists";
import { BaseAutoScreeningTemplate } from "../base-auto-screening";
import { PreArrivalRiskReviewForm } from "./tabs/forms/pre-arrival-risk-review-forms";
import { PreArrivalRiskReviewSummary } from "./tabs/summary/pre-arrival-risk-review-summary";
import { PreArrivalRiskReviewDefinitions } from "./tabs/definitions/pre-arrival-risk-review-definitions"
import { VetCriteria } from "../../../vetting/steps/vet-criteria/vet-criteria";
import { VetRulesRun } from "../../../vetting/steps/rules-run/vet-rules-run";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { useView } from "aurelia-framework";
import { type TabModel } from "@rightship-tech/common-ui/models/basic.models";

@autoinject()
@transient()
@useView('views/pages/modules/auto-screening/templates/pre-arrival-risk-review/pre-arrival-risk-review.html')
export class PreArrivalRiskReviewTemplate extends BaseAutoScreeningTemplate {

    vesselPreArrivalDetails: VesselPreArrivalDetailsModel;
    vetRiskScores: VesselPortCallRiskScoreModel[] = [];

    constructor(protected dialogClientService: DialogClientService, private vesselForms: PreArrivalRiskReviewForm,
        router: Router, i18N: I18N, eventAggregator: EventAggregator, validationsClientService: ValidationsClientService,
        bindingEngine: BindingEngine, notificationService: NotificationClientService, signalClientService: SignalClientService,
        manageVesselService: ManageVesselService, private vesselFbrPerformance:VesselFbrPerformance, private vesselLists:VesselLists,
        private preArrivalRiskReviewSummary: PreArrivalRiskReviewSummary, private preArrivalRiskReviewDefinitions: PreArrivalRiskReviewDefinitions,
        vetCriteria: VetCriteria, vetRulesRun: VetRulesRun, protected userClaimsService: UserClaimsService) {
        super(router, bindingEngine, i18N, notificationService, eventAggregator,
            validationsClientService, signalClientService, manageVesselService,
            vetCriteria, vetRulesRun, userClaimsService);

    }

    protected getSteps(): TabModel[] | Promise<TabModel[]> {
        return [
            {
                title: 'Summary',
                step: 1,
                show: true,
                vm: this.preArrivalRiskReviewSummary
            },
            {
                title: 'Feedback Reports',
                step: 3,
                show: true,
                vm: this.vesselFbrPerformance,
                getModel: (x) => {
                    return {
                        vesselId: x.vesselId
                    };
                }
            },
            {
                title: "Forms",
                step: 4,
                show: true,
                vm: this.vesselForms,
                getModel: (x) => {
                    return {
                        vesselId: x.vesselId
                    };
                }
            },
            {
                title: "Lists",
                step: 5,
                show: true,
                vm: this.vesselLists,
                getModel: (x) => {
                    return {
                        vesselId: x.vesselId
                    };
                }
            },
            {
                title: "Definitions",
                step: 6,
                show: true,
                vm: this.preArrivalRiskReviewDefinitions
            },
            ...this.getScreeningCommonSteps()
        ];
    }
}